export default __webpack_public_path__ + "static/media/next.9e7f8985.svg";